<template>
    <v-container fluid>
        <v-dialog v-model="addDialog" max-width="500px">
            <category-picker @categoryChosen="categoryChosen" @cancel="addDialog = false" :isDownload="downloadPressed" :cards="cardsLocal" />
        </v-dialog>
        <div :key="formKey">
            <template v-for="(card, i) in cardsLocal">
                <v-dialog v-if="!card.isMainCard" v-model="card.dialog" max-width="500px" :key="card.title + i">
                    <component :is="card.form" :filter="card.filter" @input="onSave" @cancel="onCancel" :readonly="readonly" />
                </v-dialog>
            </template>
        </div>
        <v-row>
            <v-btn class="mx-2" dark color="green" @click="downloadPressed = true; addDialog = true">
                Export to Excel
            </v-btn>
            <v-file-input @change="importExcelFile" ref="file" style="display: none" :key="'fileKey' + fileKey" />
            <v-btn v-if="hasImport && hasClaim(claimName, true)" color="quinary" dark class="ml-2 mb-2 float-right" @click="$refs.file.$refs.input.click()">Import from Excel</v-btn>
            <v-btn v-if="hasImport && hasClaim(claimName, true)" color="tertiary" dark class="ml-2 mb-2 float-right" @click="downloadTemplate()">Download Template</v-btn>
            <div class="flex-grow-1"></div>
            <template v-for="(card, i) in cardsLocal">
                <template v-if="!card.isMainCard">
                    <v-col xs="8" sm="4" md="3" lg="2" xl="1" class="switch-column mb-n10" :key="i">
                        <v-row class="mb-n3">
                            {{ card.title }}
                        </v-row>
                        <v-row>
                            <v-switch v-model="card.isVisible" :color="reverseToggleHandleColorDictionary[i]" />
                        </v-row>
                    </v-col>
                </template>
            </template>
            <v-btn v-if="!readonly || anyCardsAreEditable()" class="mx-2" dark large color="primary" @click="addDialog = true; downloadPressed = false">
                Add Item
            </v-btn>
        </v-row>
        <v-row justify="center">
            <v-col cols="1">
                <v-progress-circular v-if="isLoading" :size="70" :width="7" indeterminate color="tertiary" />
            </v-col>
        </v-row>
        <v-row v-masonry origin-left="true" horizontal-order="true" transition-duration="0.3s" item-selector=".item">
            <template v-for="(card, i) in cardsLocal">
                <template v-for="cardItem in card.items">
                    <v-col v-masonry-tile class="item" v-if="card.isVisible" :key="cardItem.id" xs="12" sm="6" md="4" lg="3" xl="2">
                        <component :is="card.form" :filter="card.filter" @delete="itemDeleted(card, cardItem)" @change="itemChanged(card, cardItem)" :value="cardItem" :card-color="reverseCardColorDictionary[i]" :key="cardItem.id" :is-card="true" @load="load" :readonly="readonly || !hasClaim(card.apiMethod, true)" />
                    </v-col>
                </template>
            </template>
        </v-row>
    </v-container>
</template>
<script>
    import Vue from 'vue'
    import axios from 'axios'
    import { DateTime } from 'luxon'
    import store from '../store/store';
    import exporter from '../export/exporter';
    import enumService from '../services/enumService';
    import cardColorEnum from '../enums/cardColor';
    import toggleHandleColorEnum from '../enums/toggleHandleColor';
    import { VueMasonryPlugin } from 'vue-masonry'
    Vue.use(VueMasonryPlugin)

    export default {
        props: [
            'item',
            'cards',
            'filter',
            'hasImport',
            'readonly',
            'claimName'
        ],
        components: {
            categoryPicker: () => import('../components/CategoryPicker')
        },

        data() {
            return {
                addDialog: false,
                downloadPressed: false,
                isLoading: true,
                items: [],
                formKey: 0,
                fileKey: 0,

                reverseCardColorDictionary: enumService.reverseEnum(cardColorEnum),
                reverseToggleHandleColorDictionary: enumService.reverseEnum(toggleHandleColorEnum),
            }
        },
        methods: {
            async load() {
                if (typeof (this.item) === "undefined" || this.item === null || Object.keys(this.item).length === 0) {
                    return;
                }

                this.isLoading = true;
                var promises = [];
                for (var i = 1; i < this.cards.length; i++) {
                    this.cardsLocal[i].filter = { ...this.filter, ...this.cardsLocal[i].filter };
                    this.cardsLocal[i].filter[this.cardsLocal[i].parentForeignKey] = this.item.id;
                    var params = {};
                    Object.keys(this.cardsLocal[i].filter).forEach(key => params['filter.' + key] = this.cardsLocal[i].filter[key]);
                    promises.push(axios.get('/api/' + this.cardsLocal[i].apiMethod, { params }));
                }
                var responses = await Promise.all(promises);
                var datas = [];
                responses.forEach(r => datas.push(r.data));
                for (var j = 1; j < this.cardsLocal.length; j++) {
                    this.cardsLocal[j].items = datas[j - 1].items;
                }
                this.cardsLocal[0].filter = { ...this.filter };
                if (this.cardsLocal[0].items.length === 0) {
                    this.cardsLocal[0].items.push(this.item);
                }

                this.isLoading = false;
            },
            onCancel() {
                for (var i = 0; i < this.cardsLocal.length; i++) {
                    this.$set(this.cardsLocal[i], "dialog", false);
                }
            },
            onSave() {
                this.onCancel();
                this.load();
            },
            async itemChanged(card, item) {
                var apiMethod = card.hasOwnProperty('postApiMethod') ? card.postApiMethod : card.apiMethod;
                await axios.put('/api/' + apiMethod, item);
            },
            async itemDeleted(card, item) {
                if (!confirm('Are you sure you want to delete this item?')) {
                    return;
                }
                await axios.delete('/api/' + card.apiMethod + '/' + item.id);
                if (card.isMainCard) {
                    this.$router.go(-1);
                } else {
                    this.load();
                }
            },
            anyCardsAreEditable() {
                for (var i = 0; i < this.cardsLocal.length; i++) {
                    if (this.hasClaim(this.cardsLocal[i].apiMethod, true)) {
                        return true;
                    }
                }
                return false;
            },
            categoryChosen(card) {
                if (this.downloadPressed) {
                    this.download(card)
                }
                else {
                    this.addDialog = false;
                    this.formKey++;
                    this.$set(card, "dialog", true);
                }
            },
            async download(card) {
                var params = {};
                params.listModel = {};
                params.listModel.filter = {};
                if (typeof card.filter !== 'undefined' && card.filter !== null) {
                    Object.keys(card.filter).forEach(key => params.listModel.filter[key] = card.filter[key]);
                }
                params.clientNow = DateTime.local().toISO();
                params.title = card.title;
                return axios
                    .post('/api/' + card.apiMethod + '/Export', params, { responseType: 'blob' })
                    .then(exporter.saveBlob)
                    .catch((error) => { store.dispatch('alert/error', 'There was an error downloading the file. ' + error) });
            },
            async importExcelFile(excelFile) {
                try {
                    var formData = new FormData();
                    formData.append("file", excelFile);
                    this.isLoading = true;
                    await axios.post('/api/' + this.cardsLocal[0].apiMethod + '/ImportChildren/' + this.item.id, formData);
                    store.dispatch('alert/success', 'Records imported successfully')
                    this.fileKey++;
                    await this.load();
                }
                catch (error) {
                    if (error.response && error.response.status == 400) {
                        store.dispatch('alert/error', "Server returned an error.\n" + error.response.data);
                    } else {
                        store.dispatch('alert/error', `Something went wrong: ${error}`);
                    }
                }
                finally {
                    this.isLoading = false;
                }
            },
            downloadTemplate() {
                return axios
                    .get('/api/' + this.cardsLocal[0].apiMethod + '/ChildrenTemplate', { responseType: 'blob' })
                    .then(exporter.saveBlob)
                    .catch((error) => { store.dispatch('alert/error', 'There was an error downloading the file. ' + error) });
            },
            downloadUrl(url, name) {
                fetch(url)
                    .then(resp => resp.blob())
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        // the filename you want
                        a.download = name;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(() => alert('oh no!'));
            },
        },

        watch: {
            item: {
                immediate: true,
                handler() {
                    this.load();
                }
            }
        },

        computed: {
            cardsLocal: {
                get() {
                    return this.cards;
                },
                set(cards) {
                    this.$emit("input", cards);
                },
            },
        }
    };
</script>
